

























import Vue from 'vue';
import axios from 'axios';
import { mapState } from 'vuex';
import AppHeaderGallery from '@/components/AppHeaderGallery.vue';
import userService from '@/services/hub/user';
import FolderTable from '@/components/FolderTable.vue';

export default Vue.extend({
  name: 'FolderView',
  components: {
    AppHeaderGallery,
    FolderTable,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      rootFolder: {
        name: '/',
        items: [] as any,
      },
      folders: [],
      activeTab: null,
      planOdId: 0,
      userToken: '',
      customerPlansId: 0,
      currentFolder: null,
      breadcrumb: [] as any,
      searchUpload: '',
    };
  },
  watch: {
    id: 'fetchFolder',
  },
  async mounted() {
    await this.userInformation();
  },
  methods: {
    async userInformation() {
      const userInfo = localStorage.getItem('user');
      if (userInfo) {
        const customerObjectId = JSON.parse(userInfo);
        this.customerPlansId = customerObjectId.user.plan_id;
        this.userToken = customerObjectId.token;
        await this.getPlanOd(this.customerPlansId);
        await this.getGalleryVideos(this.planOdId);
        await this.getGallery(this.planOdId);
        await this.getBreadcrumb();
      }
    },
    async getPlanOd(customerPlansId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/event/getPlanOd/${customerPlansId}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        this.planOdId = response.data.customerPlansOdId;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getGallery(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(`${apiUrl}/galleries/${planId}?`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
          },
        });
        // eslint-disable-next-line max-len
        const folderName = response.data.galleries.find((item: any) => Number(item.id) === Number(this.id));
        // eslint-disable-next-line max-len
        const folderInside = response.data.galleries.filter((item: any) => Number(item.parentId) === Number(this.id));

        if (folderInside.length > 0) {
          this.rootFolder.items = [
            ...folderInside.map((gallery: any) => ({
              id: gallery.id,
              name: gallery.name,
              type: 'folder' as const,
            })),
            ...this.rootFolder.items,
          ];
        }

        this.rootFolder.name = folderName.name;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    async getGalleryVideos(planId: number) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        const response = await axios.get(
          `${apiUrl}/galleries/videos/${planId}?search=${this.id}`,
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );

        const items = await Promise.all(
          response.data.map(async (video: any) => {
            const access = await this.fetchDailyViews(video);
            return {
              id: video.id,
              name: video.name,
              access,
              duration: video.time,
              send_date: video.created_date,
              size: video.size,
              hash: video.hash,
              storageHash: video.storage_hash,
              thumb: this.getThumbUrl(video),
              type: 'video',
            };
          }),
        );

        this.rootFolder.items = items;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
    // eslint-disable-next-line consistent-return, @typescript-eslint/camelcase
    async getViews(video_hash: any) {
      const apiUrl = process.env.VUE_APP_API_URL;
      try {
        // eslint-disable-next-line @typescript-eslint/camelcase
        const response = await axios.get(`${apiUrl}/views/${video_hash}`, {
          headers: {
            Authorization: `Bearer ${this.userToken}`,
            'Content-Type': 'application/json',
            Accept: '*/*',
          },
        });

        if (response.status !== 200) {
          throw new Error('Erro ao chamar a API');
        }

        const { data } = response;
        return data;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },

    // eslint-disable-next-line consistent-return
    async fetchDailyViews(video: any) {
      const today = new Date().toISOString().split('T')[0];
      const storageKey = `views_${video.hash}`;

      const storedItem = localStorage.getItem(storageKey);
      const storedData = storedItem ? JSON.parse(storedItem) : null;

      if (storedData && storedData.date === today) {
        // eslint-disable-next-line eqeqeq
        if (storedData.access.views.count == 0) {
          return video.access;
        }
        console.log('Access (cached):', storedData.access.views.count);
        return storedData.access.views.count;
      }

      const access = await this.getViews(video.hash);
      console.log('Access (fetched):', access?.views?.count);

      if (access && access.views && access.views.count !== undefined) {
        await this.saveVideoDetails(video, access?.views?.count);

        localStorage.setItem(storageKey, JSON.stringify({ date: today, access }));
        return access.views.count;
      }

      console.warn('Access not available, not saving to localStorage.');
    },

    async saveVideoDetails(video: any, access: any) {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        await axios.put(
          `${apiUrl}/updateVideoAccess/${this.planOdId}/${video.id}`,
          {
            access,
            parentId: video.parentId,
          },
          {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          },
        );
      } catch (error) {
        console.error('Error saving video details:', error);
      }
    },
    getThumbUrl(video: any) {
      if (video.cover && video.cover.includes('/')) {
        const coverSegment = video.cover.split('/')[6];
        if (video.storage_hash) {
          return `${video.thumbBaseUrl}${coverSegment}?uf085lum5fbz=${video.storage_hash}`;
        }
        return `${video.thumbBaseUrl}${coverSegment}`;
      } if (video.cover) {
        const coverSegment = video.cover;
        if (video.storage_hash) {
          return `${video.thumbBaseUrl}${coverSegment}?uf085lum5fbz=${video.storage_hash}`;
        }
        return `${video.thumbBaseUrl}${coverSegment}`;
      }
      return '';
    },
    async getAllVideos() {
      const apiUrl = process.env.VUE_APP_API_URL;
      if (this.searchUpload === '') {
        await this.getGalleryVideos(this.planOdId);
        await this.getGallery(this.planOdId);
      } else {
        const response = await axios.get(`${apiUrl}/videosupload/${this.planOdId}?name=${this.searchUpload}`);
        const items: any[] = [];
        // eslint-disable-next-line no-restricted-syntax
        for (const video of response.data) {
          // eslint-disable-next-line no-await-in-loop
          const access = await this.fetchDailyViews(video);
          items.push({
            id: video.id,
            name: video.name,
            access,
            duration: video.time,
            send_date: video.created_date,
            size: video.size,
            hash: video.hash,
            storageHash: video.storage_hash,
            thumb: this.getThumbUrl(video),
            type: 'video',
          });
        }

        this.rootFolder.items = items;
      }
    },
    formatVideoDuration(time: string) {
      const [hours, minutes, seconds] = time.split(':');
      return `${hours}:${minutes}:${seconds.split('.')[0]}`;
    },
    formatFileSize(size: any) {
      if (size === 0) return '0 B';

      const units = ['B', 'KB', 'MB', 'GB', 'TB'];
      const i = Math.floor(Math.log(size) / Math.log(1024));
      // eslint-disable-next-line no-restricted-properties
      return `${Math.round((size / Math.pow(1024, i)) * 100) / 100} ${units[i]}`;
    },
    formatDate(dateTimeString: string): string {
      const date = new Date(dateTimeString);
      const formattedDate = date.toLocaleDateString('pt-BR', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
      });
      return formattedDate;
    },
    async fetchFolder() {
      await this.getGalleryVideos(this.planOdId);
      await this.getGallery(this.planOdId);
      await this.getBreadcrumb();
    },
    async getBreadcrumb() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL;
        let currentId = this.id;
        const breadcrumbArray = [];

        while (currentId) {
          // eslint-disable-next-line no-await-in-loop
          const response = await axios.get(`${apiUrl}/galleries/${this.planOdId}?`, {
            headers: {
              Authorization: `Bearer ${this.userToken}`,
            },
          });

          // eslint-disable-next-line max-len, @typescript-eslint/no-explicit-any, no-loop-func
          const currentFolder = response.data.galleries.find((item: any) => Number(item.id) === Number(currentId));
          breadcrumbArray.unshift({
            id: currentFolder.id,
            name: currentFolder.name,
          });

          currentId = currentFolder.parentId;
        }

        this.breadcrumb = breadcrumbArray;
      } catch (error) {
        console.error('Erro ao chamar a API:', error);
      }
    },
  },
});
